import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=67ea3760&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ea3760')) {
      api.createRecord('67ea3760', component.options)
    } else {
      api.reload('67ea3760', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=67ea3760&", function () {
      api.rerender('67ea3760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZJivm9L9rg0E/JS/comp/ImgFallback2.vue"
export default component.exports